import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CMS } from '../../utils/CMS';
import { ResidentDiscountArrowStyle, ResidentDiscountInfoStyle } from './ResidentDiscountMessage.style';
import { withPageContext } from '../../utils/PageContext';
import { TrackingUtils } from '../../utils';

const RESIDENT_KEYS = {
    children: {
        title: 'residentDiscount.widget.pluskids.title',
    },
    default: {
        title: 'residentDiscount.firstinfo.body',
        body: 'residentDiscount.main.ifSomePassengers',
    },
};

const ResidentDiscountMessageDesktop = ({ trackEvent, hasNonAdults, isResidentDiscountPaxType, regionsText }) => {
    const [isOpen, setOpen] = React.useState(false);
    const [isLoaded, setLoaded] = React.useState(false);

    const toggle = (toState = null) => {
        const newOpenState = !isOpen;
        trackEvent({
            action: TrackingUtils.ACTION.FLIGHTS,
            label: TrackingUtils.LABEL.residentDiscountArrow(newOpenState),
        });
        setOpen(typeof toState === 'boolean' ? toState : newOpenState);
    };

    const arrowClassNames = classNames({
        'odf-icon odf-icon-arrow-down od-arrow-resident': true,
        'open': isOpen,
    });

    const infoClassNames = classNames({
        'odf-bg-base odf-space-inner-m odf-text-soft odf-text-md': true,
        'open': isOpen,
    });

    const trackOnLoad = () => {
        trackEvent({
            action: TrackingUtils.ACTION.FLIGHTS,
            label: 'resident_discount_msg_onload',
        });
        setLoaded(true);
    };

    !isLoaded && trackOnLoad();

    const residentKeys = hasNonAdults && !isResidentDiscountPaxType
        ? RESIDENT_KEYS.children
        : RESIDENT_KEYS.default;

    return (
        <div>
            <span onClick={toggle} className="odf-text-info odf-link-expander">
                <span className="odf-icon odf-icon-information odf-icon-xl" />
                <span className="odf-space-inner-left-s odf-space-inner-right-s">
                    <CMS id="residentDiscount.firstinfo.tittle" />
                </span>
                <ResidentDiscountArrowStyle className={arrowClassNames} />
            </span>
            <ResidentDiscountInfoStyle className={infoClassNames}>
                <div>
                    <CMS id={residentKeys.title} values={{ residentZone: regionsText }} dangerouslySetInnerHTML />
                </div>
                <br />
                <div>
                    {residentKeys.body && <CMS id={residentKeys.body} />}
                </div>
            </ResidentDiscountInfoStyle>
        </div>
    );
};

ResidentDiscountMessageDesktop.propTypes = {
    trackEvent: PropTypes.func.isRequired,
    hasNonAdults: PropTypes.bool.isRequired,
    isResidentDiscountPaxType: PropTypes.bool.isRequired,
    regionsText: PropTypes.string.isRequired,
};

const withContext = withPageContext(ResidentDiscountMessageDesktop);
export { withContext as ResidentDiscountMessageDesktop };
